import auth from "../../firebase/auth";
import api from "../../api";
import { createSuccess, createError } from "../../libs/flash-messages";

const findIndex = (state, id) => {
   return state.services.findIndex(service => {
      return service._id === id;
   });
}

const state = {
   filters: {
      name: "",
      status: "any",
      type: "any",
      sort: "a-z"
   },
   services: null
}

const getters = {
   getServices(state) {
      return state.services
   },
   getServiceFilters(state) {
      return state.filters;
   },
   getFilteredServices(state) {
      const filters = state.filters;
      let status = null;
      if (filters.status === "any") {
         status = "any";
      } else if (filters.status === "active") {
         status = true;
      } else {
         status = false;
      }
      if (state.services) {
         return state.services
            .filter(service => {
               if (filters.name) {
                  return service.name.toLowerCase().includes(filters.name.toLowerCase());
               }
               return service
            })
            .filter(service => {
               if (filters.status !== 'any') {
                  return service.active === status;
               }
               return service;
            })
            .filter(service => {
               if (filters.type !== "any") {
                  return service.type === filters.type;
               }
               return service
            })
            .sort((a, b) => {
               if (filters.sort === "a-z") {
                  if (a.name > b.name) {
                     return -1;
                  } else if (a.name < b.name) {
                     return 1
                  } else {
                     return 0
                  }
               } else {
                  if (a.name > b.name) {
                     return 1;
                  } else if (a.name < b.name) {
                     return -1
                  } else {
                     return 0
                  }
               }
            });
      } else {
         return [];
      }
   }
}

const actions = {
   async startSetServices({ commit, rootState }) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      try {
         const services = await api.axiosGet("/api/compliance/services/", token)
         commit('SET_SERVICES', services);
      } catch (err) {
         createError("Failed to fetch", err);
      }
   },
   startUnsetServices({ commit }) {
      commit("SET_SERVICES", null)
   },
   async startCreateService({ rootState }, form) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      try {
         const service = await api.axiosPost("/api/compliance/services", form, token);
         this._vm.$socket.io.nsps["/compliance"].emit("CREATE_SERVICE", service);
         createSuccess(`Successfully created: ${service.name}`);
      } catch (err) {
         createError("Failed to create", err);
      }
   },
   async startUpdateService({ rootState }, form) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      try {
         await api.axiosPut(`/api/compliance/services/${form._id}`, form, token);
         this._vm.$socket.io.nsps["/compliance"].emit("UPDATE_SERVICE", form);
         createSuccess("Successfully updated!")
      } catch (err) {
         createError("Failed to update", err);
         return Promise.reject(err);
      }
   },
   async startDeleteService({ rootState }, id) {
      const token = rootState.user.token;
      await auth.refreshFlow(auth.provider);
      try {
         await api.axiosDelete(`/api/compliance/services/${id}`, token);
         this._vm.$socket.io.nsps["/compliance"].emit("DELETE_SERVICE", id);
         createSuccess("Successfully deleted!")
      } catch (err) {
         createError("Failed to delete", err);
         return Promise.reject(err);
      }
   },
   startSetServiceFilters({ commit }, form) {
      commit('SET_NAME_FILTER', form.name);
      commit('SET_STATUS_FILTER', form.status);
      commit('SET_TYPE_FILTER', form.type);
      commit('SET_SORT_FILTER', form.sort);
   }
}

const mutations = {
   SET_SERVICES(state, data) {
      state.services = data
   },
   SET_NAME_FILTER(state, name) {
      state.filters.name = name;
   },
   SET_STATUS_FILTER(state, status) {
      state.filters.status = status;
   },
   SET_TYPE_FILTER(state, type) {
      state.filters.type = type;
   },
   SET_SORT_FILTER(state, sort) {
      state.filters.sort = sort;
   },
   SOCKET_COMP_REATE_SERVICE(state, service) {
      if (state.services) {
         state.services.push(service);
      } else {
         state.services = [service];
      }
   },
   SOCKET_COMP_UPDATE_SERVICE(state, form) {
      const serviceFound = findIndex(state, form._id);
      state.services.splice(serviceFound, 1, form);
   },
   SOCKET_COMP_DELETE_SERVICE(state, id) {
      const serviceFound = findIndex(state, id);
      state.services.splice(serviceFound, 1);
   }
}

export default {
   state,
   getters,
   actions,
   mutations
}